export default __webpack_public_path__ + "static/media/product4.d1743ca0.jpg";